export const toUtcDate = (date) => {
  const split = (date || '').split(' ')

  if (split.length !== 2) {
    return date
  }

  return new Date(Date.parse(date)).toISOString().substr(0, 16).replace('T', ' ')
}
